import { withDefaults } from '@warp-drive/legacy/model/migration-support';
import type { WithLegacy } from '@warp-drive/legacy/model/migration-support';
import type { Type } from '@warp-drive/core/types/symbols';

export type EnrichmentJob = WithLegacy<{
  itemId: string | null;
  itemType: string | null;
  status: string | null;
  attempts: number | null;
  maxAttempts: number | null;
  lastError: string | null;
  nextRetryAt: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  completedAt: string | null;
  [Type]: 'enrichment-jobs';
}>;

export const EnrichmentJobSchema = withDefaults({
  type: 'enrichment-jobs',
  fields: [
    { name: 'itemId', kind: 'attribute', type: 'string' },
    { name: 'itemType', kind: 'attribute', type: 'string' },
    { name: 'status', kind: 'attribute', type: 'string' },
    { name: 'attempts', kind: 'attribute', type: 'number' },
    { name: 'maxAttempts', kind: 'attribute', type: 'number' },
    { name: 'lastError', kind: 'attribute', type: 'string' },
    { name: 'nextRetryAt', kind: 'attribute', type: 'string' },
    { name: 'createdAt', kind: 'attribute', type: 'string' },
    { name: 'updatedAt', kind: 'attribute', type: 'string' },
    { name: 'completedAt', kind: 'attribute', type: 'string' },
  ],
});
